import * as React from 'react';
const LockIcon = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={20} height={20} fill='none' viewBox='0 0 20 20' {...props}>
		<path
			fill='#000'
			fillOpacity={0.65}
			d='M13.82 6.749v-.813A4.07 4.07 0 0 0 9.754 1.87 4.07 4.07 0 0 0 5.69 5.936v2.438h-.813c-.896 0-1.626.73-1.626 1.626v6.503c0 .897.73 1.626 1.626 1.626h9.755c.897 0 1.626-.729 1.626-1.626V10c0-.896-.73-1.626-1.626-1.626H7.316V5.936a2.442 2.442 0 0 1 2.439-2.44 2.442 2.442 0 0 1 2.438 2.44v.813h1.626ZM14.631 10l.002 6.503H4.877V10h9.755Z'
		/>
	</svg>
);
export default LockIcon;
